const sortingRule_Products = [
  "Подсолнечник Рядовой",
  "Подсолнечник ВО",
  "Рапс",
  "Ячмень",
  "Кукуруза",
  "Соя",
  "Пшеница",
  "Пшеница 2 класс",
  "Пшеница 3 класс",
  "Пшеница 4 класс",
];

export default sortingRule_Products;
